import { Injector, NgModule } from '@angular/core';
import { MatDialogModule } from '@angular/material/dialog';

import { setAppInjector } from '@frontend/sports/host-app/sports-product/feature/utils';
import { provideSportsWebCore, provideSportsWebRootServices } from '@frontend/sports/web/platform-lib';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';

@NgModule({
    imports: [
        StoreModule.forRoot(
            {},
            {
                runtimeChecks: {
                    strictStateImmutability: false,
                    strictActionImmutability: false,
                    strictStateSerializability: false,
                    strictActionSerializability: false,
                },
            },
        ),
        // extModules,
        MatDialogModule,
        EffectsModule.forRoot([]),
    ],
    providers: [provideSportsWebCore(), provideSportsWebRootServices()],
})
export class AppModule {
    constructor(injector: Injector) {
        setAppInjector(injector);
    }
}
